import React, { useEffect, useState } from 'react';
import {
  cancelToken,
  get,
  responseParser,
} from '@fareye/utils';
import { IMapper } from '@fareye/common'


const SailingSchedules = (props: IMapper) => {
  const {baseUrl, authToken} = props;
  const [token, setToken] = useState(null);
  const [tokenTime, setTokenTime] = useState<Date | null>(null); // store datetime when token was issued
  useEffect(() => {
    const fetchToken = async () => {
      const source = cancelToken().source();

      try {
        const { data } = responseParser(
          await get(`${baseUrl}/api/v2/sailing_schedules`, source.token,
            {
              headers: { 'Authorization': `Bearer ${authToken}`}
            }
          )
        );

        const issuedAt = new Date(data.token_created_at);
        setToken(data.token);
        setTokenTime(issuedAt);
      } catch (error) {
        console.error('Failed to fetch token:', error);
      }
    };

    // Initial token fetch
    fetchToken();

    // Check every 30 minuts if token is older than 1 minute
    const interval = setInterval(() => {
      if (tokenTime) {
        const now = new Date();
        const threeAndHalfHoursAgo = new Date(now.getTime() - (3 * 60 + 30) * 60 * 1000);
        if (tokenTime < threeAndHalfHoursAgo) {
          console.log('Token expired, refreshing...');
          fetchToken();
        }
      }
    }, 30 * 60 * 1000); // 30 minutes interval

    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, []);

  const iframeSrc = token
    ? `https://app.portcast.io/embed/sailing_schedules?token=${token}`
    : null;

  return (
    <div>
      <h1 style={{ marginLeft: '20px' }}>Sailing Schedules Dashboard</h1>
      {iframeSrc ? (
        <iframe
          src={iframeSrc}
          title="Sailing Schedules dashboard"
          style={{
            width: '100%',
            height: '1000px',
            border: '1px solid #ccc',
          }}
        />
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
};

export { SailingSchedules};
